import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const resendExternalReturnShippingProviderLabel = {
  name: "resendExternalReturnShippingProviderLabel" as const,
  input: z.object({
    returnId: zExt.objectId(),
    emailOverride: z.email().optional(),
  }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
